import HtmlContent from './HtmlContent';

export default HtmlContent;
